import { render, staticRenderFns } from "./noteItem.vue?vue&type=template&id=6b832d67&"
import script from "./noteItem.vue?vue&type=script&lang=js&"
export * from "./noteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b832d67')) {
      api.createRecord('6b832d67', component.options)
    } else {
      api.reload('6b832d67', component.options)
    }
    module.hot.accept("./noteItem.vue?vue&type=template&id=6b832d67&", function () {
      api.rerender('6b832d67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/noteItem.vue"
export default component.exports